/* TROÇO commerce: progressive enhancement over Shopify forms. */
(() => {
  if (window.trocoCommerceReady) return;
  window.trocoCommerceReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const cartDialog = () => document.getElementById('TrocoCart');
  let busy = false;
  let returnFocus;
  function renderCart(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-troco-cart-content]');
    if (!content) throw new Error('Não foi possível atualizar o carrinho.');
    cartDialog().querySelector('[data-troco-cart-body]').replaceChildren(content);
    document.querySelectorAll('[data-troco-count]').forEach(el => el.textContent = content.dataset.count);
  }
  function showCart() {
    const dialog = cartDialog();
    if (!dialog.open) { returnFocus = document.activeElement; dialog.showModal(); }
  }
  async function refreshCart() {
    const response = await fetch(root + 'cart?section_id=troco-cart', { headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Não foi possível carregar o carrinho. Tente novamente.');
    renderCart(await response.text());
  }
  async function openCart() {
    showCart();
    const status = cartDialog().querySelector('[data-troco-cart-status]');
    status.textContent = 'Carregando seus troços…';
    try { await refreshCart(); status.textContent = ''; }
    catch (error) { status.textContent = error.message; }
  }
  async function changeQuantity(key, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    const dialog = cartDialog();
    const status = dialog.querySelector('[data-troco-cart-status]');
    dialog.setAttribute('aria-busy', 'true');
    status.textContent = 'Atualizando…';
    try {
      const response = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['troco-cart'],sections_url:location.pathname})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Não foi possível alterar a quantidade.');
      if (data.sections?.['troco-cart']) renderCart(data.sections['troco-cart']); else await refreshCart();
      status.textContent = 'Carrinho atualizado.';
    } catch(error) { status.textContent = error.message; }
    finally { busy = false; dialog.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-troco-cart-open]');
    if (opener && cartDialog() && typeof cartDialog().showModal === 'function') { event.preventDefault(); openCart(); }
    if (event.target.closest('[data-troco-cart-close]')) cartDialog()?.close();
    const remove = event.target.closest('[data-troco-remove]');
    if (remove) changeQuantity(remove.dataset.key, 0);
    if (event.target === cartDialog()) {
      const box = cartDialog().getBoundingClientRect();
      if(event.clientX < box.left || event.clientX > box.right) cartDialog().close();
    }
  });
  document.addEventListener('close', event => { if(event.target.id === 'TrocoCart') returnFocus?.focus(); }, true);
  document.addEventListener('change', event => {
    const input = event.target;
    if(input.matches('[data-troco-quantity]')) changeQuantity(input.dataset.key, Number(input.value));
    if(input.matches('[data-troco-upload]')) input.setCustomValidity(input.files[0]?.size > 20*1024*1024 ? 'Escolha uma imagem de até 20 MB.' : '');
    if(input.matches('[data-troco-variant]')) {
      const section = input.closest('[data-troco-product]');
      const option = input.selectedOptions[0];
      section.querySelectorAll('[data-troco-price]').forEach(el => el.textContent = option.dataset.price);
      const compare = section.querySelector('[data-troco-compare]');
      compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare;
      section.querySelectorAll('[data-troco-submit]').forEach(button => { button.dataset.label ||= button.textContent; button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'ESGOTADO' : button.dataset.label; });
      const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState({}, '', url);
      const media = document.getElementById(option.dataset.media);
      if(media) media.scrollIntoView({behavior:'auto',block:'nearest',inline:'center'});
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-troco-add]');
    if(!form || !cartDialog() || typeof cartDialog().showModal !== 'function') return;
    event.preventDefault();
    if(busy) return;
    const section = form.closest('[data-troco-product]');
    const status = form.querySelector('[data-troco-product-status]');
    const personal = form.querySelector('.troco-personalize');
    if(personal && !form.querySelector('[data-troco-upload]').files.length && !Array.from(form.querySelectorAll('[data-troco-idea]')).some(el => el.value.trim())) {
      status.textContent = 'Envie uma imagem, escreva uma frase ou conte sua ideia para começar.';
      form.querySelector('[data-troco-idea]').focus(); return;
    }
    if(!form.reportValidity()) return;
    const buttons = section.querySelectorAll('[data-troco-submit]');
    buttons.forEach(button => { button.dataset.label ||= button.textContent; button.disabled = true; button.textContent = 'ADICIONANDO…'; });
    busy = true; status.textContent = '';
    let added = false;
    try {
      const body = new FormData(form); body.append('sections', 'troco-cart'); body.append('sections_url', location.pathname);
      const response = await fetch(root+'cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});
      const data = await response.json();
      if(!response.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar este troço.');
      added = true;
      if(data.sections?.['troco-cart']) renderCart(data.sections['troco-cart']); else await refreshCart();
      cartDialog().querySelector('[data-troco-cart-status]').textContent = 'TROÇO adicionado.';
      showCart(); status.textContent = 'Adicionado ao carrinho.';
    } catch(error) {
      status.textContent = added ? 'Produto adicionado. Abra o carrinho para conferir.' : error.message;
    } finally {
      busy = false;
      const available = form.querySelector('[data-troco-variant]').selectedOptions[0].dataset.available === 'true';
      buttons.forEach(button => {button.disabled = !available; button.textContent = available ? button.dataset.label : 'ESGOTADO';});
    }
  });
})();


/* Product gallery: thumbnail selection and accessible lightbox. */
(() => {
  const setup = () => {
    document.querySelectorAll('[data-troco-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('.troco-gallery-main__image');
      const modal = gallery.querySelector('[data-gallery-modal]');
      const modalImage = gallery.querySelector('[data-gallery-modal-image]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const open = gallery.querySelector('[data-gallery-open]');
      const close = gallery.querySelector('[data-gallery-close]');
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      let active = 0;
      if (!main || !thumbs.length) return;
      const show = (index) => {
        active = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[active];
        main.src = thumb.dataset.full;
        main.alt = thumb.dataset.alt || '';
        if (modalImage) {
          modalImage.src = thumb.dataset.full;
          modalImage.alt = thumb.dataset.alt || '';
        }
        thumbs.forEach((item, i) => item.classList.toggle('is-active', i === active));
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
      const closeModal = () => {
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('troco-gallery-open');
        open?.focus();
      };
      open?.addEventListener('click', () => {
        if (!modal) return;
        show(active);
        modal.hidden = false;
        document.body.classList.add('troco-gallery-open');
        close?.focus();
      });
      close?.addEventListener('click', closeModal);
      prev?.addEventListener('click', () => show(active - 1));
      next?.addEventListener('click', () => show(active + 1));
      modal?.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
      document.addEventListener('keydown', (event) => {
        if (!modal || modal.hidden) return;
        if (event.key === 'Escape') closeModal();
        if (event.key === 'ArrowLeft') show(active - 1);
        if (event.key === 'ArrowRight') show(active + 1);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();})();
  (()=>{const r=()=>document.querySelectorAll('.troco-product-gallery').forEach(g=>{if(g.dataset.enhanced)return;const a=[...g.querySelectorAll('img')].map(i=>[i.currentSrc||i.src,i.alt]);if(!a.length)return;g.dataset.enhanced='1';let n=0;g.replaceChildren();const m=document.createElement('button'),mi=document.createElement('img'),t=document.createElement('div'),d=document.createElement('div'),di=document.createElement('img');m.type='button';m.className='troco-gallery-main';mi.className='troco-gallery-main__image';m.append(mi);t.className='troco-gallery-thumbs';d.className='troco-gallery-lightbox';d.hidden=true;const c=document.createElement('button');c.type='button';c.className='troco-gallery-lightbox__close';c.textContent='×';const p=document.createElement('button');p.type='button';p.className='troco-gallery-lightbox__nav troco-gallery-lightbox__prev';p.textContent='←';const x=document.createElement('button');x.type='button';x.className='troco-gallery-lightbox__nav troco-gallery-lightbox__next';x.textContent='→';d.append(c,p,di,x);const s=i=>{n=(i+a.length)%a.length;mi.src=di.src=a[n][0];mi.alt=di.alt=a[n][1];[...t.children].forEach((b,j)=>b.classList.toggle('is-active',j===n))};a.forEach((v,i)=>{const b=document.createElement('button'),im=document.createElement('img');b.type='button';b.className='troco-gallery-thumb';im.src=v[0];im.alt=v[1];b.append(im);b.onclick=()=>s(i);t.append(b)});m.onclick=()=>{d.hidden=false;document.body.classList.add('troco-gallery-open')};c.onclick=()=>{d.hidden=true;document.body.classList.remove('troco-gallery-open')};p.onclick=()=>s(n-1);x.onclick=()=>s(n+1);d.onclick=e=>{if(e.target===d)c.click()};g.append(m,t,d);s(0)});document.readyState==='loading'?document.addEventListener('DOMContentLoaded',r):r()})();
